// extracted by mini-css-extract-plugin
export default {"intro":"ModalNuevoIngresoAlumno_intro__68oO8","input":"ModalNuevoIngresoAlumno_input__L2yk3"};